export default class CreateAssetModel {
    organizationId = null;
    name = null;
    description = null;
    siteId = null;

    constructor(name, description, organizationId, siteId = null){
        this.organizationId = organizationId;
        this.name = name;
        this.description = description;
        this.siteId = siteId;
    }
}
